export class Message {
  constructor(
    public id?: number,
    public sender?: string,
    public question?: string,
    public isQuestionType?: boolean,
    public reply?: string
  ) {}
}
